"use client"
import React, { useState, useEffect } from "react";
import { useAppData } from "@/lib/providers/AppDataProvider";
import { Alert } from "react-bootstrap";
import { SERVICE_PROFILE_ACTION_OPTIONS } from "@/components/crm/serviceProfile/constants";
import { SERVICE_PROFILE_CONDITION_OPTIONS } from "@/components/crm/serviceProfile/constants";
const ServiceProfileItemSummary = ({
  item,
  selectedSearchOption,
  condensed = false,
  showNotes = false,
  shortNotes = false
}) => {

  const [matchingListings, setMatchingListings] = useState(null);

  useEffect(() => {
    if (item && selectedSearchOption) {
      const matchingListings = item.serviceProfile?.serviceListings?.filter(
        l => {
          return (
            l.items.includes(selectedSearchOption.value) ||
            l.categories.includes(selectedSearchOption.value)
          );
        }
      );
      setMatchingListings(
        matchingListings?.length > 0 ? matchingListings : null
      );
    }
  }, [item, selectedSearchOption]);

  const { flattenedServiceCategories: serviceCategoriesFlattened } = useAppData();

  const categoryToLabel = category => {
    return serviceCategoriesFlattened.find(c => c.value === category)?.label;
  };

  const listings = matchingListings || item.serviceProfile?.serviceListings;
  if (listings) {
    return (
      <div className="default-flex-column-layout" style={{ gap: "0.25rem" }}>
        {listings.map((listing, index) => {
          if (index < 2) {
            return (
              <div className="tags">
                {listing.actions.map(action => (
                  <span className={`tag action ${action} medium`}>
                    {SERVICE_PROFILE_ACTION_OPTIONS.find(a => a.value === action)?.label}
                  </span>
                ))}
                {listing.conditions.map(condition => (
                  <span className={`tag condition ${condition} medium`}>
                    {SERVICE_PROFILE_CONDITION_OPTIONS.find(c => c.value === condition)?.label}
                  </span>
                ))}
                {condensed ? (
                  <>
                    {listing.categories.length > 2 &&
                      listing.categories.slice(0, 1).map((category, index) => {
                        return (
                          <span
                            className={`tag service-profile category ${category} medium`}
                          >
                            {categoryToLabel(category)}
                          </span>
                        );
                      })}
                    {listing.categories.length > 2 && (
                      <span className="tag service-profile category medium">
                        +{listing.categories.length - 2}
                      </span>
                    )}
                    {listing.categories.length <= 2 &&
                      listing.categories.map((category, index) => {
                        return (
                          <span
                            className={`tag service-profile category ${category} medium`}
                          >
                            {categoryToLabel(category)}
                          </span>
                        );
                      })}
                  </>
                ) : (
                  <>
                    {listing.categories.map((category, index) => {
                      return (
                        <span
                          className={`tag service-profile category ${category} medium`}
                        >
                          {categoryToLabel(category)}
                        </span>
                      );
                    })}
                  </>
                )}
                {listing.feeRequired && (
                  <span className="tag medium with-icon">
                    <i className="fa-solid fa-money-check-dollar"></i>
                    <span className="medium">
                      <strong>Fee Required</strong>
                    </span>
                  </span>
                )}
                {listing.subscriptionRequired && (
                  <span className="tag medium with-icon">
                    <i className="fa-kit fa-solid-clock-seven-circle-dollar"></i>
                    <span className="medium">
                      <strong>Subscription Required</strong>
                    </span>
                  </span>
                )}
              </div>
            );
          } else {
            return <></>;
          }
        })}
        {/* <div className="tags">
          {item.serviceProfile?.serviceListings?.length > 2 && (
            <span className="tag service-profile category medium">
              + {item.serviceProfile?.serviceListings?.length - 2} more
            </span>
          )}
        </div> */}
        {showNotes &&
          matchingListings &&
          matchingListings.length > 0 &&
          matchingListings[0].notes && (
            <div style={{ marginTop: "0.5rem" }}>
              <Alert
                variant="warning"
                className={shortNotes ? "short-notes" : ""}
                style={{ marginBottom: "0.25rem" }}
              >
                <i className="fa-solid fa-triangle-exclamation"></i>
                {shortNotes ? (
                  <span style={{ marginLeft: "0.25rem" }}>
                    IMPORTANT: Review guidelines prior to visit.
                  </span>
                ) : (
                  <span style={{ marginLeft: "0.25rem" }} className="medium">
                    {matchingListings[0].notes}
                  </span>
                )}
              </Alert>
            </div>
          )}
      </div>
    );
  } else {
    return <></>;
  }
};

export default ServiceProfileItemSummary;
